import aiGenerateService from '@services/aiGenerateService.js';
/**
 * AI Option Model
 *
 * กำหนด options ทั้งหมดของ AI tool
 * แต่ละ option มี field `contexts` ระบุว่าใช้ได้กับ widget ประเภทไหน
 * - 'text'  : widget ข้อความ
 * - 'image' : widget รูปภาพ
 * - 'video' : widget วิดีโอ
 *
 * ถ้าไม่ระบุ contexts = ใช้ได้ทุก context
 */

export const AI_OPTION_CONTEXTS = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  ALL: 'all',
};

export const AI_OPTIONS = [
  {
    id: 'create',
    label: 'engine.aiOption.lblCreate',
    icon: require('@assets/images/icon/ai_gentext.svg'),
    hasSubmenu: false,
    contexts: [AI_OPTION_CONTEXTS.TEXT],
  },
  {
    id: 'shorten',
    label: 'engine.aiOption.lblShorten',
    icon: require('@assets/images/icon/ai_text_shorter.svg'),
    hasSubmenu: false,
    contexts: [AI_OPTION_CONTEXTS.TEXT],
  },
  {
    id: 'expand',
    label: 'engine.aiOption.lblExpand',
    icon: require('@assets/images/icon/ai_text_longer.svg'),
    hasSubmenu: false,
    contexts: [AI_OPTION_CONTEXTS.TEXT],
  },
  {
    id: 'tone',
    label: 'engine.aiOption.lblTone',
    icon: require('@assets/images/icon/ai_exchange.svg'),
    hasSubmenu: true,
    contexts: [AI_OPTION_CONTEXTS.TEXT],
    submenu: []
  },
  {
    id: 'translate',
    label: 'engine.aiOption.lblTranslate',
    icon: require('@assets/images/icon/ai_flag.svg'),
    hasSubmenu: true,
    contexts: [AI_OPTION_CONTEXTS.TEXT],
  },
];

export async function getContentTone() {
  const response = await aiGenerateService.getContentTone();
  if(response && response.success && response.data) {
    return response.data;
  } else {
    return [];
  }
}

/**
 * Filter options ตาม context
 * @param {string} context - 'text' | 'image' | 'video' | 'all'
 * @param {Array} options - custom options หรือใช้ default AI_OPTIONS
 * @returns {Array}
 */
export async function getAIOptionsByContext(context, options = AI_OPTIONS) {
  if (context === AI_OPTION_CONTEXTS.ALL) return options;
  if(context === AI_OPTION_CONTEXTS.TEXT) {
    const isExistPromptTone = options.some(option => option.id === 'tone');
    if(isExistPromptTone) {
      const toneOptions = await getContentTone();
      if(toneOptions && toneOptions.length > 0) {
        options.find(option => option.id === 'tone').submenu = toneOptions.map(tone => ({
          id: tone.id,
          label: tone.name,
          description: tone.description || tone.name || '',
        }));
        return options;
      }
    }
  }

  return options.filter(
    (option) => !option.contexts || option.contexts.includes(context)
  );
}

/**
 * Map widgetType → AI option context
 * @param {string} widgetType - e.g. 'SECTION_WIDGET_IMAGE'
 * @returns {string}
 */
export function getContextByWidgetType(widgetType) {
  const IMAGE_TYPES = ['SECTION_WIDGET_IMAGE', 'SECTION_WIDGET_IMAGE_GALLERY'];
  const VIDEO_TYPES = ['SECTION_WIDGET_YOUTUBE'];

  if (IMAGE_TYPES.includes(widgetType)) return AI_OPTION_CONTEXTS.IMAGE;
  if (VIDEO_TYPES.includes(widgetType)) return AI_OPTION_CONTEXTS.VIDEO;
  return AI_OPTION_CONTEXTS.TEXT;
}

export default {
  AI_OPTION_CONTEXTS,
  AI_OPTIONS,
  getAIOptionsByContext,
  getContextByWidgetType,
};
